export default __webpack_public_path__ + "static/media/NotoSansSCRegular-subset.6633f330.woff2";